/** Is the market data recent enough to call CANLI rather than GECİKMELİ? */

// Collectors run every 5 min, cache_page holds 60s, the page polls every 60s.
// A threshold at the collection interval flags a healthy pipeline as stale.
export const LIVE_THRESHOLD_MS = 8 * 60 * 1000;

interface Timestamped {
  timestamp?: string | null;
}

/** Newest row, not the first: BIST and S&P refresh hourly, currencies every 5 min. */
export const newestTimestamp = (rows: Timestamped[]): string | undefined => {
  let newest: string | undefined;
  for (const row of rows) {
    if (!row?.timestamp) continue;
    const value = new Date(row.timestamp).getTime();
    if (Number.isNaN(value)) continue;
    if (newest === undefined || value > new Date(newest).getTime()) newest = row.timestamp;
  }
  return newest;
};

export const dataAgeMs = (timestamp: string | undefined, now = Date.now()): number | null => {
  if (!timestamp) return null;
  const value = new Date(timestamp).getTime();
  return Number.isNaN(value) ? null : now - value;
};

export const isDataLive = (age: number | null): boolean =>
  age !== null && age >= 0 && age <= LIVE_THRESHOLD_MS;
